// Navbar.js
import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { clearToken } from "../../utils/authUtils";
import {
  FaCog,
  FaChartBar,
  FaChartLine,
  FaEnvelope,
  FaComments,
  FaSignOutAlt,
  FaUser,
} from "react-icons/fa";
import { Button } from "react-bootstrap";

import {
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Box,
  Typography,
  Divider,
  Tooltip,
} from '@mui/material';
import { FiArrowLeft } from "react-icons/fi";


const TopNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [wallet, setWallet] = useState(() => {
  return Number(localStorage.getItem("walletBalance")) || 1200;
});
useEffect(() => {
  localStorage.setItem("walletBalance", wallet);
}, [wallet]);

useEffect(() => {
  const updateWallet = () => {
    setWallet(Number(localStorage.getItem("walletBalance")) || 0);
  };

  window.addEventListener("walletUpdated", updateWallet);

  return () => {
    window.removeEventListener("walletUpdated", updateWallet);
  };
}, []);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const deleteCookies = () => {
    const cookies = document.cookie.split('; ');
    cookies.forEach((cookie) => {
      const cookieName = cookie.split('=')[0];
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
  };

  const handleLogout = () => {
    handleClose();
    clearToken();
    localStorage.removeItem('loggedInUser');
    sessionStorage.removeItem('authToken');
    deleteCookies();
    navigate('/login');
  };

  return (
    <div className="top-navbar flex-between gap-16" style={{ backgroundColor: "#F8FAFC", padding: "0" }}>
      <div className="flex-align gap-16">
        <button
          type="button"
          className="toggle-btn d-xl-none d-flex text-26 text-gray-500"
          onClick={() => navigate("/sidebar-mob")}
        >
          <i className="ph ph-list"></i>
        </button>

        {/* Back Button */}
        {/* Back Button (hide on admin dashboard) */}
        {location.pathname !== "/admin-dashboard2" && (
          <div className="back-button-container" style={{ marginLeft: "20px", marginTop: "0px" }}>
            <button
              className="back-button"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.5rem",
                padding: "0.5rem 1rem",
                background: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: "0.75rem",
                color: "#475569",
                fontSize: "0.875rem",
                fontWeight: 500,
                cursor: "pointer",
                transition: "all 0.2s",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
              }}
              onClick={() => navigate(-1)}
            >
              <FiArrowLeft size={16} />
              Back
            </button>
          </div>
        )}


        <form action="#" className="w-350 d-sm-block d-none">
          <div className="position-relative">
            <button
              type="submit"
              className="input-icon text-xl d-flex text-gray-100 pointer-event-none"
            >
              {/* <i className="ph ph-magnifying-glass"></i> */}
            </button>
            {/* <input
              type="text"
              className="form-control ps-40 h-40 border-transparent focus-border-main-600 bg-main-50 rounded-pill placeholder-15"
              placeholder="Search..."
            /> */}
          </div>
        </form>
      </div>

      <div
        className="top-navbar flex-between"
        style={{ border: "none", padding: "0", borderRadius: "50%" }}
      >
        {/* Right Section */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>

  {/* 💰 WALLET */}
<div
  onClick={() => navigate("/wallet")}
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "6px 12px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #ffffff, #f1f5f9)",
    border: "1px solid #e2e8f0",
    cursor: "pointer",
    transition: "all 0.25s ease",
    boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
    minWidth: "130px"
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "translateY(-3px)";
    e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.06)";
  }}
>

  {/* ICON */}
  <div
    style={{
      // width: "36px",
      // height: "36px",
      borderRadius: "10px",
      // background: "Gray",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      fontSize: "18px",
    
    }}
  >
    💳
  </div>

  {/* TEXT */}
  <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.1 }}>
    <span style={{
      fontSize: "9px",
      color: "#64748b",
      fontWeight: "500"
    }}>
      Wallet Balance
    </span>

    <span style={{
      fontSize: "13px",
      fontWeight: "700",
      color: "#1e293b",
      letterSpacing: "0.3px"
    }}>
  ₹{wallet}
    </span>
  </div>

</div>

  {/* 👤 AVATAR */}
  <Tooltip title="Profile">
    <IconButton onClick={handleAvatarClick}>
      <Avatar
        alt="User Avatar"
        src="https://img.icons8.com/fluent/1200/test-account.jpg"
        sx={{ width: 40, height: 40, border: '2px solid #474EB5' }}
      />
    </IconButton>
  </Tooltip>

  {/* MENU */}
  <Menu
    anchorEl={anchorEl}
    open={open}
    onClose={handleClose}
    onClick={handleClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    sx={{
      '& .MuiMenu-paper': {
        minWidth: 180,
        borderRadius: 2,
      },
    }}
  >
    <MenuItem
      component={Link}
      to="/profile"
      sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
    >
      <FaUser size={18} />
      View Profile
    </MenuItem>
    <Divider />
    <MenuItem
      onClick={handleLogout}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        color: 'red',
      }}
    >
      <FaSignOutAlt size={18} />
      Logout
    </MenuItem>
  </Menu>

</Box>
      </div>
      {/* Dropdown Animation Style */}
      <style>
        {`
    

    .dropdown-menu {
      
    
   
      background-color: white;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    }

    .dropdown-item {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 500;
      padding: 10px 15px;
      
      transition: background 0.3s ease-in-out, transform 0.2s ease-in-out;
    }

    .dropdown-item:hover {
      background: #f8f9fa;
     
    }

    .dropdown-item svg {
      color: #6a11cb;
    }

    .dropdown-item.text-danger svg {
      color: red;
    }
  `}
      </style>
    </div>
  );
};

export default TopNav;
